import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import fr from './locales/fr.json';
import qaRtl from './locales/qa-rtl.json';

/**
 * Locale config.
 *
 * Shipping locales: en (default), fr.
 * QA-only pseudo-locale: qa-rtl — used in CI visual regression to verify
 * the UI renders correctly when forced into right-to-left direction.
 * Adding a real RTL locale (e.g., Arabic) later is a translation-file drop-in.
 */
export const SUPPORTED_LOCALES = ['en', 'fr'] as const;
export const QA_LOCALES = ['qa-rtl'] as const;
export const ALL_LOCALES = [...SUPPORTED_LOCALES, ...QA_LOCALES] as const;

const RTL_LOCALES = new Set<string>(['ar', 'he', 'fa', 'ur', 'qa-rtl']);

export function isRtlLocale(locale: string | undefined): boolean {
  if (!locale) return false;
  return RTL_LOCALES.has(locale);
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: import.meta.env.DEV ? [...ALL_LOCALES] : [...SUPPORTED_LOCALES],
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      'qa-rtl': { translation: qaRtl },
    },
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'mycity-locale',
    },
  });

export default i18n;
